import CrudApi from './crud';

export const crud = new CrudApi('/schools/:schoolId/students', { only: ['index'] });
